var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamepad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 528.807 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF6"
    },
    d: "M 479.838 98.475 C 441.217 73.855 391.348 72.596 377.217 83.927 C 353.493 102.952 320.941 107.428 285.631 107.428 C 250.321 107.428 217.769 102.951 194.045 83.927 C 179.914 72.596 130.045 73.855 91.424 98.475 C 64.477 115.653 29.631 306.066 29.631 358.104 C 29.631 405.105 48.307 425.852 73.769 429.725 C 103.195 434.202 135.562 402.867 162.045 376.009 C 188.528 349.151 250.321 340.198 285.631 340.198 C 320.941 340.198 382.734 349.15 409.217 376.009 C 435.7 402.867 468.067 434.202 497.493 429.725 C 522.955 425.852 541.631 405.105 541.631 358.104 C 541.631 306.066 506.785 115.653 479.838 98.475 Z",
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 103.963219, -82.397308)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D7DEED"
    },
    cx: 176.552,
    cy: 264.828,
    r: 52.966,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626389, -74.513977)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C7CFE2"
    },
    cx: 256,
    cy: 176.552,
    r: 26.483,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626434, -74.514008)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M 531.164 107.526 C 492.543 82.906 442.674 81.647 428.543 92.978 C 404.819 112.003 372.267 116.478 336.957 116.478 C 301.647 116.478 269.095 112.001 245.371 92.978 C 231.24 81.647 181.371 82.906 142.75 107.526 C 139.148 109.822 135.404 115.289 131.623 123.029 C 174.488 104.232 204.732 103.207 224.405 103.207 C 234.336 103.207 256.761 123.374 265.233 128.586 C 279.578 137.414 306.612 139.069 336.957 139.069 C 367.302 139.069 394.336 137.414 408.681 128.586 C 417.152 123.373 439.578 103.207 449.509 103.207 C 469.182 103.207 499.427 104.232 542.291 123.029 C 538.51 115.288 534.766 109.822 531.164 107.526 Z",
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 58.827736, -108.456215)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2FA50"
    },
    d: "M 312.804 209.844 C 295.769 209.844 281.907 195.981 281.907 178.947 C 281.907 161.913 295.77 148.05 312.804 148.05 C 329.838 148.05 343.701 161.913 343.701 178.947 C 343.701 195.981 329.839 209.844 312.804 209.844 Z M 312.804 156.879 C 300.632 156.879 290.735 166.78 290.735 178.948 C 290.735 191.116 300.632 201.017 312.804 201.017 C 324.976 201.017 334.873 191.116 334.873 178.948 C 334.873 166.78 324.976 156.879 312.804 156.879 Z",
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 80.067787, -96.193375)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626358, -74.514114)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M203.034,185.379h-8.828c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h8.828c4.875,0,8.828,3.953,8.828,8.828l0,0C211.862,181.427,207.91,185.379,203.034,185.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M317.793,185.379h-8.828c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h8.828c4.875,0,8.828,3.953,8.828,8.828l0,0C326.621,181.427,322.668,185.379,317.793,185.379z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D7DEED"
    },
    cx: 335.448,
    cy: 264.828,
    r: 52.966
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626358, -74.514114)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#707487"
    },
    cx: 176.552,
    cy: 264.828,
    r: 44.138
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#707487"
    },
    cx: 335.448,
    cy: 264.828,
    r: 30.897
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D7DEED"
    },
    cx: 105.931,
    cy: 176.552,
    r: 52.966,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626373, -74.51403)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#707487"
    },
    cx: 105.931,
    cy: 176.552,
    r: 30.897,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626373, -74.51403)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#82B9FF"
    },
    cx: 370.759,
    cy: 176.552,
    r: 17.655,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626495, -74.513985)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6464"
    },
    cx: 441.379,
    cy: 176.552,
    r: 17.655,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626511, -74.513969)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626358, -74.514114)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M219.432,254.769c-3.808-16.266-16.556-29.013-32.822-32.822c-0.724,2.414-1.231,4.92-1.231,7.57 c0,14.626,11.857,26.483,26.483,26.483C214.511,256,217.018,255.493,219.432,254.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M133.672,254.769c2.414,0.724,4.92,1.231,7.57,1.231c14.626,0,26.483-11.857,26.483-26.483 c0-2.649-0.506-5.156-1.231-7.57C150.228,225.756,137.48,238.504,133.672,254.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M219.432,274.887c-2.414-0.724-4.92-1.231-7.57-1.231c-14.626,0-26.483,11.857-26.483,26.483 c0,2.649,0.506,5.156,1.231,7.57C202.876,303.9,215.624,291.152,219.432,274.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M141.241,273.655c-2.649,0-5.156,0.506-7.57,1.231c3.808,16.266,16.556,29.013,32.822,32.822 c0.724-2.414,1.231-4.92,1.231-7.57C167.724,285.512,155.868,273.655,141.241,273.655z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00DCC8"
    },
    cx: 406.069,
    cy: 211.862,
    r: 17.655,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626495, -74.513962)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDC50"
    },
    cx: 406.069,
    cy: 141.241,
    r: 17.655,
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 132.626511, -74.513992)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M 375.424 360.902 C 347.115 328.002 281.06 317.034 243.315 317.034 C 205.57 317.034 139.515 328.001 111.206 360.902 C 86.81 389.256 57.745 417.074 30.044 421.987 C 30.517 422.072 30.975 422.192 31.453 422.265 C 60.879 426.742 93.246 395.407 119.729 368.548 C 146.212 341.689 208.005 332.736 243.315 332.736 C 278.625 332.736 340.418 341.688 366.901 368.547 C 393.384 395.406 425.751 426.74 455.177 422.264 C 455.655 422.191 456.114 422.071 456.586 421.986 C 428.885 417.074 399.82 389.256 375.424 360.902 Z",
    transform: "matrix(0.939693, 0.34202, -0.34202, 0.939693, 141.174698, -60.913036)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepad);
export default __webpack_public_path__ + "static/media/gamepad.b45d2ff9b0207e802402d10b164048b8.svg";
export { ForwardRef as ReactComponent };